import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { projectsData } from "../data/projectsData";
import "../styles/projects.css";
import CTASection from '../components/CTASection';

export default function Projects() {
  const heroProject = projectsData[0];

  const hero = {
    title: `${heroProject.title}`,
    chips: [
      heroProject.location,
      heroProject.services?.length ? heroProject.services.join(" • ") : null,
    ].filter(Boolean),
    image: heroProject.b.image,
  };

  // Preload the hero image for faster loading
  useEffect(() => {
    if (hero.image) {
      const img = new Image();
      img.src = hero.image;
    }
  }, [hero.image]);

  return (
    <div className="projects">
      <Navbar />

      {/* HERO */}
      <section className="projects-hero">
        <div
          className="projects-hero__bg"
          style={{ backgroundImage: `url(${hero.image})` }}
          aria-hidden="true"
        />
        <div className="projects-hero__content">
          <h1 className="projects-hero__title">{hero.title}</h1>
          <div className="projects-hero__chips">
            {hero.chips.map((c, i) => (
              <span key={i} className="projects-chip">{c}</span>
            ))}
          </div>
        </div>
      </section>

      {/* ABC SECTIONS (snap one per viewport) */}
      <main className="projects-snap">
        {projectsData.map((sec) => (
          <section
            className="abc-section"
            key={sec.id}
            id={sec.id}
            aria-labelledby={`${sec.id}-heading`}
          >
            {/* Section header with clickable title */}
            <header className="abc-header">
              <h2 id={`${sec.id}-heading`} className="abc-section-title">
                <Link
                  to={`/projects/${sec.id}`}
                  className="abc-section-title__link"
                >
                  {sec.title}
                </Link>
              </h2>
            </header>

            {/* A — Before */}
            <article className="abc-col abc-col--a">
              <div className="abc-label">{sec.a.label}</div>
              {sec.a.title && <h3 className="abc-title">{sec.a.title}</h3>}
              {sec.a.body && <p className="abc-body">{sec.a.body}</p>}
              {sec.a.image && (
                <figure className="abc-figure">
                  <img src={sec.a.image} alt={`${sec.a.label} — ${sec.a.title || ""}`} />
                </figure>
              )}
            </article>

            {/* B — Finished (bigger center) */}
            <article className="abc-col abc-col--b">
              <div className="abc-label">{sec.b.label}</div>
              <figure className="abc-figure abc-figure--hero">
                <img src={sec.b.image} alt={`${sec.b.label} view`} />
                {sec.b.caption && <figcaption className="abc-caption">{sec.b.caption}</figcaption>}
              </figure>
              {sec.b.cta && (
                <div className="abc-cta">
                  <Link to={sec.b.cta.to} className="btn-primary">
                    {sec.b.cta.label}
                  </Link>
                </div>
              )}
            </article>

            {/* C — During */}
            <article className="abc-col abc-col--c">
              <div className="abc-label">{sec.c.label}</div>
              {!!sec.c.images?.length && (
                <div className="during-stack">
                  {sec.c.images.slice(0, 2).map((src, i) => (
                    <figure key={i} className="abc-figure">
                      <img src={src} alt={`During ${i + 1}`} />
                    </figure>
                  ))}
                </div>
              )}
              {!!sec.c.list?.length && (
                <ul className="during-list">
                  {sec.c.list.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              )}
            </article>
          </section>
        ))}
      </main>

      {/* Final CTA */}
     <CTASection 
  title="Ready to start your project?"
  subtitle="Browse Our Gallery"
  galleryLink="/Gallery"
  showEmergency={false}
/>
    </div>
  );
}
